import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Checkbox, FormControlLabel, Paper, TextField, Tooltip } from '@material-ui/core'; 

import { PaymentReport, PaymentAwbReport, PaymentReportPayment }  from '../../models/PaymentReport';
import PaymentDetailsAwbsServices from '../../models/PaymentDetailsAwbsServices';

import { formatCurrency } from '../../utils/currencyFormatter';
import { getAdditionalServiceName, getAdditionalServiceDetails, getPaymentSourceName } from '../../utils/additionalServices';
import { paymentMethodMap } from '../../utils/paymentMethodMap';

import moment from 'moment';
import { Badge } from '@material-ui/core';
import IsoIcon from '@material-ui/icons/Iso';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import cartStyles from '../cart/cart.module.css';
import commonStyles from '../common/common.module.css';
import paymentStyles from './paymentReportStyles.module.css';
import { AddBoxRounded } from '@material-ui/icons';
const PADDING_RIGHT = 0;
const PADDING_LEFT = '3px';

const SELL_STYLE_PRINT =  { paddingTop: '10px', verticalAlign: 'top',paddingRight: PADDING_RIGHT , paddingLeft: PADDING_LEFT, fontSize: '0.7rem'}
const SELL_STYLE_RENDER =  { paddingTop: '10px', verticalAlign: 'top',paddingRight: PADDING_RIGHT }
const HEADER_STYLE_PRINT = { paddingRight: PADDING_RIGHT, paddingLeft: PADDING_LEFT }
const HEADER_STYLE_RENDER = { paddingRight: PADDING_RIGHT }
const SELL_STYLE_RENDER_PC =  { paddingTop: '10px', width: '2%', verticalAlign: 'top',paddingRight: PADDING_RIGHT }
const SELL_STYLE_RENDER_SOURCE =  { paddingTop: '10px', width: '10%', verticalAlign: 'top',paddingRight: PADDING_RIGHT }
const SELL_STYLE_RENDER_DETAIL =  { paddingTop: '10px', width: '17%', verticalAlign: 'top',paddingRight: PADDING_RIGHT }
const SELL_STYLE_RENDER_WGT =  { paddingTop: '10px', width: '12%', verticalAlign: 'top',paddingRight: PADDING_RIGHT }


const iconFontSize = 20;
const styles = (theme: Theme) =>

  createStyles({
    wrapper: {
      borderRadius: '15px',
      marginBottom: '30px',
      padding: '20px',
      backgroundColor: 'var(--greybkg)'
    },
    header: {
      fontWeight: 600,
      color: 'var(--primaryblue)',
      fontSize: '16px',
      marginTop: '0',
      marginBottom: 0,
    },
    paper: {
      backgroundColor: 'transparent',
    },
    button: {
      width: '100px',
      height: '40px'
    },
    btnWrapper: {
      marginTop: '30px',
      marginBottom: '30px',
      textAlign: 'right'
    },
    remarksText: {
      width: '250px'
    },
    badge: {
      '&>span': {
        background: 'red',
        color: 'white',
        height: '14px',
        minWidth: '14px',
        fontSize: '9px',
        right: '3px',
        fontWeight: 800,
        top: '2px',
      }
    },
    disabledBadgeIcon: {
      '&>span': {
        color: 'rgb(204, 204, 204)',
        borderColor: 'rgb(204, 204, 204)'
      }
    },
    centteredCell: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    },
    materialIcon: {
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    addBox: {
      fontSize: '20px !important',
      color: 'var(--primaryblue)'
    },
    addBoxGreen: {
      fontSize: '20px !important',
      color: 'green'
    },
    PaymentPaper: {
      '& td:nth-last-child(4), & td:nth-last-child(6)':{
        verticalAlign: 'bottom !important',
      }
    }
  });

interface PaymentReportTableProps {
    classes: any;
    payments: PaymentReport;
    view: string;
    loading?: boolean;
    exportCsv: () => void;
    changeRemarks: (event: any, code: string, number: string) => void;
    changeSettled: (id: number) => void;
    openRemarks: (type: string, id: number, number: string, version: number, remarks: string, payment?: PaymentAwbReport) => void; 
};

const paymentReportTable = ( props: PaymentReportTableProps ) => {

  const { classes } = props;
  
  const sellStyle = props.view === 'print'? SELL_STYLE_PRINT : SELL_STYLE_RENDER;
  const sellStylePc = props.view === 'print'? SELL_STYLE_PRINT : SELL_STYLE_RENDER_PC;
  const sellStyleSource = props.view === 'print'? SELL_STYLE_PRINT : SELL_STYLE_RENDER_SOURCE;
  const sellStyleDetails = props.view === 'print'? SELL_STYLE_PRINT : SELL_STYLE_RENDER_DETAIL;
  const headerStyle = props.view === 'print'? HEADER_STYLE_PRINT : HEADER_STYLE_RENDER
  const paymentSourceStyle = props.view === 'print'? cartStyles.paymentSourcePrint : cartStyles.paymentSourceRender;
  const sellStylefee = props.view === 'print'? SELL_STYLE_PRINT : SELL_STYLE_RENDER_WGT;

  
  return (
 
    <Fragment>
      <div className={ `${ classes.wrapper } ${ cartStyles.wrapper }` }>
        <h3 className={classes.header}> Payments</h3>
        <div className={ `${ paymentStyles.tableWrapper }`}>
          <MaterialTable

            components={{Container: props => <Paper {...props} elevation={0} className={ `${ classes.paper } ${ classes.PaymentPaper } ` }/>}}

            data = { props.payments.awbs }

            columns = {[
              { title: 'Airwaybill', cellStyle:  sellStyle, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => { 

                  return <span>{ rowData.code }-{ rowData.number }</span>;
                }
              },
              { title: 'Processed By', cellStyle: sellStyle, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {

                  return <div>
                    <div>WH: { rowData.wh_user }</div>
                    <div>CT: { rowData.counter_user } </div>
                  </div>;
                }
              },
              { title: 'Arrival Date', cellStyle: sellStyle, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {

                  const arrivalDate: string = rowData.arrival_date ? moment(rowData.arrival_date).format('DD-MMM-YY').toUpperCase() : '';
                  return <span>{ arrivalDate }</span>;
                }
              },
              { title: 'Pcs', field: 'pieces' , cellStyle: sellStyle, headerStyle: headerStyle },
              { title: 'Wgt', field: 'weight', cellStyle: sellStyle, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {

                  const weight: number = +(rowData.weight);
                  return <span>{ weight.toFixed(1) }K</span>;
                },  
              },
              { title: 'Fee', cellStyle: sellStylefee, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {

                  const fees: Array<JSX.Element> = rowData.payments.map((payment: PaymentReportPayment, index: number) => (
                  <div key = {index }>
                    <div>{ payment.services.map((service: PaymentDetailsAwbsServices , index: number) => (
                      <div key={ index } className={ `${ cartStyles.feeName } ${ paymentStyles.minHeight }` }>
                        { getAdditionalServiceName(service.type) }:
                        { service.type === 'other' || service.type === 'gha_adjust'? ' ' + service.params.reason : '' }
                      </div>
                    ))}
                      <div className={ cartStyles.height45 }/>
                    </div>
                  </div>
                    
                  ));
                  return <div>
                    <div>{ fees }</div>
                    { rowData.adjustments.map((payment: any, index: number) => (
                        <div key = {index }>
                          <div key={ index } className={ `${ cartStyles.feeName } ${ paymentStyles.minHeight }` }>
                          { 'Post Delivery Adjustment' }
                          </div>
                      </div>
                      
                      ))}
                    </div>;
                }
              },
              { title: 'Details', cellStyle: sellStyleDetails, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {

                  const dues: Array<JSX.Element> = rowData.payments.map((payment: PaymentReportPayment, index: number) => (
                    <div key = {index }>
                      <div>{ payment.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                        <div key={ index } className={ `${ cartStyles.dueRow } ${ paymentStyles.minHeight }` }>
                          <div>{ getAdditionalServiceDetails(service, +rowData.weight) }</div>
                        </div>
                      ))}
                      </div>
                  </div>
                  ));
                    return <div>
                        <div>{ dues }</div>
                        { rowData.adjustments.map((payment: any, index: number) => (
                        <div key = {index }>
                          <div key={ index } className={ `${ cartStyles.feeName } ${ paymentStyles.minHeight }` }>
                          { payment.reason }
                        </div>
                        </div>
                    
                        )) }
                    </div>;
                }
              },
              { title: 'Amount', cellStyle: sellStyle, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {
                  const paymentAmount: Array<JSX.Element> = rowData.payments.map((payment: PaymentReportPayment, index: number) => (
                    <div key = {index }>
                      <div>
                        { payment.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                          <div key={ index } className={ `${ cartStyles.dueRow } ${ paymentStyles.minHeight }` }>
                            <div>$</div>
                            <div>{ formatCurrency(service.amount, 2,) }</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ));
                  return (<div>
                     <div>{ paymentAmount }</div>
                     { rowData.adjustments.map((payment: any, index: number) => (
                        <div key = {index }>
                          <div key={ index } className={ `${ cartStyles.feeName } ${ paymentStyles.minHeight }` }>
                          <div key={ index } className={ `${ cartStyles.dueRow } ${ paymentStyles.minHeight }` }>
                            <div>$</div>
                              <div>{ formatCurrency(Number(payment.amount), 2,) }</div>
                            </div>
              
                        </div>
                        </div>
                    
                      ))}
                  </div>
                 
                  )
                }
              },
              { title: 'Transaction Date', cellStyle: sellStyle, headerStyle: headerStyle,
              render: (rowData: PaymentAwbReport) => {
                const paymentSource: Array<JSX.Element> = rowData.payments.map((payment: PaymentReportPayment, index: number) => (
                  <div key = {index }>
                    <div>
                      { payment.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                        <div key={ index } className={ `${ cartStyles.paymentSrc } ${ paymentStyles.minHeight }` }>
                    <div/>
                    { moment(service.timestamp).format('DD-MMM-YY').toUpperCase()}
                        </div>
                      ))}
                    </div>
                    <div className={ cartStyles.height45 }/>
                    </div>
                ));
                return (
                  <div>
                      <div>{ paymentSource }</div>
                      { rowData.adjustments.map((payment: any, index: number) => (
                      <div key = {index }>
                      <div key={ index } className={ `${ cartStyles.feeName } ${ paymentStyles.minHeight }` }>
                      { moment(payment.pay_date_set).format('DD-MMM-YY').toUpperCase()}
                      </div>
                  </div>
                  
                    ))}
                  </div>
                )
              }
            },
              {
                title: 'Total', field: 'amount_collected', cellStyle: sellStyle, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {
                  const totalSum = rowData.payments.reduce((sum, payment) => sum + payment.total, 0);
                  return (
                    <div className={`${cartStyles.dueRow}  ${cartStyles.dueSumRow} ${paymentStyles.minHeight}`}>
                      <div>{formatCurrency(totalSum, 2)}</div>
                    </div>
                  );
                },
              },
              {
                title: 'Payment Source', cellStyle: sellStyleSource, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {
                  const paymentSource: Array<JSX.Element> = rowData.payments.map((payment: PaymentReportPayment, index: number) => (
                    <div key={index}>
                      <div>
                        {payment.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                          <div key={index} className={`${cartStyles.paymentSrc} ${paymentStyles.minHeight}`}>
                            <div />
                            {service.payment_method === 'alternative payment' ? service.reason.manualReason : service.payment_method}
                          </div>
                        ))}
                      </div>
                      <div className={cartStyles.height45} />
                    </div>
                  ));

                  return (
                    <div>
                      <div>{paymentSource}</div>
                      {rowData.adjustments.map((payment: any, index: number) => (
                        <div key={index}>
                          <div key={index} className={`${cartStyles.feeName} ${paymentStyles.minHeight}`}>
                            {getPaymentSourceName(payment.source)}
                          </div>
                        </div>

                      ))}
                    </div>
                  )
                }
              },
              { title: 'Total Collected', field: 'amount_collected', cellStyle: sellStyle, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {

                  return    <div className={ cartStyles.dueRow }>
                  <div>$</div>
                    <div>{ formatCurrency(rowData.amount_collected, 2,) }</div>
                  </div>;
                },
              },
              { title: 'Balance', field: 'amount_collected', cellStyle: sellStyle, headerStyle: headerStyle,
                render: (rowData: PaymentAwbReport) => {

                  return    <div className={ cartStyles.dueRow }>
                  <div>$</div>
                    <div>{ rowData.balance >= 0 ? `${formatCurrency(rowData.balance, 2,)}` : `(${formatCurrency(Math.abs(rowData.balance), 2,)})` }</div>
                  </div>;
                },
              },
            
              { title: 'Audit', cellStyle: sellStyle, headerStyle: headerStyle,
              render: (rowData: PaymentAwbReport) => {
              return (
                <Tooltip title="Audit">
                <Badge className={ `${classes.badge}` } color="secondary">
                  <IsoIcon className={ rowData.settled ? `${classes.materialIcon} ${classes.addBoxGreen}` : `${classes.materialIcon} ${classes.addBox}` }
                    onClick={ () => props.openRemarks('audit', rowData.payment_id, rowData.code + '-' + rowData.number, rowData.version, rowData.remarks, rowData) } 
                  />                 
                </Badge>
           
              </Tooltip>
                )
                }
              }
            ]}
          
            options = {{
              selection: false,
              paging: false,
              pageSize: 10,
              search: false,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 0,
              },
              showTitle: false,
              pageSizeOptions: [15,20],
              toolbar: true,
              exportButton: true,
              exportCsv: props.exportCsv ,
              sorting: false,
              rowStyle: {
                verticalAlign: 'top'
              }
            }}
          />
          { props.loading && (
            <div style={{ textAlign: 'center', padding: '15px', color: 'var(--primaryblue)', fontWeight: 600 }}>
              Loading more rows...
            </div>
          )}
        </div>
      </div>
      <div className={ cartStyles.bottomRow }>
        <div className={ cartStyles.totalWrapper }>
          <span className= { cartStyles.totalLabel }>Total AWB's:</span>
          <span>{ props.payments.count }</span>
        </div>
        <div className={ cartStyles.totalWrapper }>
          <span className= { cartStyles.totalLabel }>Total Fees:</span>
          <span>{ formatCurrency(props.payments.total, 2, '$') }</span>
        </div>
        <div className={ cartStyles.totalWrapper }>
          <span className= { cartStyles.totalLabel }>Total Collected:</span>
          <span>{ formatCurrency(props.payments.totalCollectedAmount, 2, '$') }</span>
        </div>
        <div className={ cartStyles.totalWrapper }>
          <span className= { cartStyles.totalLabel }>Balance:</span>
          <span>{ formatCurrency(props.payments.balanceDue, 2, '$') }</span>
        </div>
      </div>
    

      <div className={ classes.btnWrapper }>

      </div>

    </Fragment>
       
  );
};

export default withStyles(styles)(paymentReportTable);